/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 11:29:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 17:59:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/slice/index.ts
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  getCollapse as _getCollapse,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getHasModified as _getHasModified,
  getLastModified as _getLastModified,
  getLoaded as _getLoaded,
  getState as _getState,
  getUuid as _getUuid,
  reducerTarget,
  willUnmount,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/slice/common';
import { EnumReducers } from 'src/pages/SalesCannelVersion/SalesChannelLegal/slice/constants';
import { duplicateErrCode } from 'src/pages/SalesCannelVersion/SalesChannelLegal/tools';
import { getLegalPage, postLegalPage } from 'src/request/salesChannel/legal';
import {
  assData,
  clearError,
  generateErrorKey,
  timeoutScroll as scroll,
} from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { modal } from 'src/utils/Modal';
import {
  EnumCollapseId,
  common,
  defaultStatus,
  generateCollapseOpen,
  generateContent,
  generateLegalSetting,
  generatePageSetting,
  generateSeoSetting,
} from '../common';
import {
  validation as _validation,
  convertDataFromServerToRedux,
} from '../tools';
export { EnumCollapseId };

export const fetchLegalPage = createAsyncThunk(
  'fetchSalesChannelLegalPageDetail',
  async (
    data: any,
    //thunkAPI,
  ) => {
    const { uuid, params, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getLegalPage(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitLegalPage = createAsyncThunk(
  'submitSalesChannelLegalPageDetail',
  async (obj: any) =>
    //thunkAPI,
    {
      const { data, params } = obj;
      const isPrimary = isCurrentPrimary();

      const response = await postLegalPage(data, {
        ...(params || {}),
        handleErrorAsResolve: true,
      });

      return { response, isPrimary };
    },
);

// export const validation = createAsyncThunk(
//   'validateSalesChannelLegalPageDetail',
//   async () => {
//     const isPrimary = await isCurrentPrimary();
//     return { isPrimary };
//   },
// );

const legalEditorReducers = (state, reducer) => {
  const reducers = [EnumReducers.legalEditor, reducer];
  const _r = reducerTarget(state, reducers);
  return _r;
};

const collapseOpen = generateCollapseOpen([
  EnumCollapseId.PageSetting,
  EnumCollapseId.SeoSetting,
  EnumCollapseId.LegalSetting,
  EnumCollapseId.Content,
  EnumCollapseId.MiniProgramShare,
]);
const pageSetting = generatePageSetting();
const seoSetting = generateSeoSetting();
const legalSetting = generateLegalSetting();
const content = generateContent();
const defaultState = {
  ...common,
  ...defaultStatus,
  collapseOpen,
  pageSetting,
  seoSetting,
  legalSetting,
  content,
  hasLinkedToTC: false,
  miniProgramPageInfo: {},
  miniProgramShare: {},
};
const salesChannelLegalLegalPageEditor = createSlice({
  name: 'salesChannelLegalLegalPageEditor',
  initialState: defaultState,
  reducers: {
    updateEssentialData(state, action) {
      const { salesChannelUuid, index } = action.payload;

      state.salesChannelUuid = salesChannelUuid;
      state.pageSetting.name = 'Legal Page ' + index || '1';
      state.loaded = true;
    },
    resetData(state) {
      willUnmount({ state, defaultState });
    },
    onCollapseChange(state, action) {
      const { id, status } = action.payload;
      state.collapseOpen[id] = status;
    },
    onPageSettingChange(state, action) {
      state.hasModified = true;
      state.pageSetting = {
        ...state.pageSetting,
        ...clearError(action.payload),
      };
    },
    onSeoSettingChange(state, action) {
      state.hasModified = true;
      state.seoSetting = {
        ...state.seoSetting,
        ...clearError(action.payload),
      };
    },
    onLegalSettingChange(state, action) {
      state.hasModified = true;
      const { useDefaultLegalSetting } = action.payload;
      if (useDefaultLegalSetting) {
        state.legalSetting[generateErrorKey('entityRegistrationNumber')] =
          false;
        state.legalSetting[generateErrorKey('entityName')] = false;
      }
      state.legalSetting = {
        ...state.legalSetting,
        ...clearError(action.payload),
      };
    },
    onContentChange(state, action) {
      state.hasModified = true;
      state.content = {
        ...state.content,
        ...clearError(action.payload),
      };
    },
    onMiniProgramShareChange(state, action) {
      state.hasModified = true;
      state.miniProgramShare = {
        ...state.miniProgramShare,
        ...action.payload,
      };
    },
    validation(state, action) {
      state.dataValid = _validation(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLegalPage.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(fetchLegalPage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(fetchLegalPage.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;
      const _data = convertDataFromServerToRedux(response) || {};
      assData(state, _data);
      if (isClone) state.hasModified = true;
    });
    builder.addCase(submitLegalPage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitLegalPage.rejected, (state, ...rest) => {
      state.loaded = true;
    });
    builder.addCase(submitLegalPage.fulfilled, (state, action) => {
      const { response } = action.payload;
      const { __requestRejected, errorCode, errMsg } = response;
      state.loaded = true;

      if (__requestRejected) {
        if (errorCode == duplicateErrCode) {
          state.pageSetting['nameIsValid'] = false;
          state.timeoutRef.push(scroll('SalesChannelLegalPageEditorPageName'));
        } else {
          modal.error({
            title: getI18nFromGeneral('general.tools_server.requestError'),
            content: errMsg || 'System Error, Please Contact Admin',
            onCancel: () => {
              console.error(errMsg || 'System Error, Please Contact Admin');
            },
            onCancelText: 'Confirm',
          });
        }
      } else {
        const _data: any = convertDataFromServerToRedux(response) || {};
        msg.success(
          getI18nFromGeneral('general.status.changessavesuccessfully'),
        );

        assData(state, { ..._data });
      }
    });
  },
});
export const {
  resetData,
  onCollapseChange,
  onPageSettingChange,
  onSeoSettingChange,
  onLegalSettingChange,
  onContentChange,
  updateEssentialData,
  validation,
  onMiniProgramShareChange,
} = salesChannelLegalLegalPageEditor.actions;

const getPageSetting = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'pageSetting'),
    (pageSetting) => {
      return pageSetting;
    },
  );
};

const getPageName = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'pageSetting').name,
    (state: any) => legalEditorReducers(state, 'salesChannelName'),
    (name, salesChannelName) => {
      return { name, salesChannelName };
    },
  );
};

const getSeoSetting = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'seoSetting'),
    (seoSetting) => {
      return seoSetting;
    },
  );
};

const getLegalSetting = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'legalSetting'),
    (legalSetting) => {
      return legalSetting;
    },
  );
};

const getContent = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'content'),
    (state: any) => legalEditorReducers(state, 'loaded'),
    (content, loaded) => {
      return { content, loaded };
    },
  );
};

const getCollapse = (id) => {
  return _getCollapse(EnumReducers.legalEditor, id);
};

const getState = () => {
  return _getState(EnumReducers.legalEditor);
};

const getHasModified = () => {
  return _getHasModified(EnumReducers.legalEditor);
};

const getUuid = () => {
  return _getUuid(EnumReducers.legalEditor);
};

const getLoaded = () => {
  return _getLoaded(EnumReducers.legalEditor);
};

const getLastModified = () => {
  return _getLastModified(EnumReducers.legalEditor);
};

const getGeneralMiniProgramShare = () => {
  return _getGeneralMiniProgramShare(EnumReducers.legalEditor);
};

const getGeneralMiniProgramPageInfo = () => {
  return _getGeneralMiniProgramPageInfo(EnumReducers.legalEditor);
};

export {
  getCollapse,
  getContent,
  getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare,
  getHasModified,
  getLastModified,
  getLegalSetting,
  getLoaded,
  getPageName,
  getPageSetting,
  getSeoSetting,
  getState,
  getUuid,
};

export default salesChannelLegalLegalPageEditor.reducer;
